const DELAY_THRESHOLD_MS = 24 * 60 * 60 * 1000;

export type TOnRoadDelayCheckParams = {
	now: Date;
	pickupHasOccurred: boolean;
	scheduledPickupAt: Date | null;
	dropoffHasOccurred: boolean;
	scheduledDropoffAt: Date | null;
}

export const ADMIN_DELAYED_HOVER_TEXT = 'The carrier is running late with picking up OR dropping off this load, please update milestone once information received.';
export const SHIPPER_DELAYED_HOVER_TEXT = 'This shipment may be delayed, we are investigating for you.';

/**
 * Dynamic "delayed" check for the allocated/onroad pill hover text (AP2-1720 follow-up): unlike the
 * base status enum, this is recomputed against the current time each time it's read, not stored.
 */
export const isPickupOrDropoffDelayed = (params: TOnRoadDelayCheckParams): boolean => {
	const { now, pickupHasOccurred, scheduledPickupAt, dropoffHasOccurred, scheduledDropoffAt } = params;
	if (!pickupHasOccurred && scheduledPickupAt) {
		return now.getTime() - scheduledPickupAt.getTime() > DELAY_THRESHOLD_MS;
	}
	if (pickupHasOccurred && !dropoffHasOccurred && scheduledDropoffAt) {
		return now.getTime() - scheduledDropoffAt.getTime() > DELAY_THRESHOLD_MS;
	}
	return false;
}

export const getStaticAdminOnRoadHoverText = (params: TOnRoadDelayCheckParams): string => {
	return isPickupOrDropoffDelayed(params) ? ADMIN_DELAYED_HOVER_TEXT : 'This shipment is on the way.';
}

export const getStaticShipperOnRoadHoverText = (params: TOnRoadDelayCheckParams): string => {
	return isPickupOrDropoffDelayed(params) ? SHIPPER_DELAYED_HOVER_TEXT : 'This shipment is on the way.';
}
